import { Account, UpdateAccountDataForm, UpdateAccountPasswordForm } from 'core/user/Account';
import UserRole from 'core/shared/enum/UserRole';
import ApiMethods from 'core/shared/enum/ApiMethod';

import { SignInRequest } from 'core/user/UserRequest';
import { SignInResponse } from 'core/user/UserResponse';

import http from './request';

const signIn = (data: SignInRequest): Promise<SignInResponse> => {
  return http.request({
    url: '/auth/signin',
    method: ApiMethods.POST,
    data,
  });
};

const signOut = (): Promise<{}> => {
  return http.request({
    url: '/auth/signout',
    method: ApiMethods.GET,
  });
};

const requestResetPassword = (email: string): Promise<{}> => {
  return http.request({
    url: '/users/reset-password',
    method: ApiMethods.POST,
    data: {
      email
    }
  });
};

const validateResetPasswordToken = (token: string): Promise<{}> => {
  return http.request({
    url: '/users/reset-password/validate',
    method: ApiMethods.POST,
    data: {
      token
    }
  });
};

const resetPassword = (password: string, token: string): Promise<{}> => {
  return http.request({
    url: '/users/reset-password/update',
    method: ApiMethods.POST,
    data: {
      password,
      token
    }
  });
};

const getAccountData = (userRole: UserRole): Promise<{ data: Account }> => {
  return http.request({
    url: userRole === UserRole.ROLE_SUPER_USER ? '/users/super-users/profile' : userRole === UserRole.ROLE_ACCOUNT_MANAGER ? '/users/account-managers/profile' : '/clients/profile',
    method: ApiMethods.GET,
  });
};

const getAppData = (): Promise<{ data: { appVersion: string } }> => {
  return http.request({
    url: '/management/version/',
    method: ApiMethods.GET,
  });
};

const logError = (error: string, stacktrace: string): Promise<{}> => {
  return http.request({
    url: '/logs',
    method: ApiMethods.POST,
    data: {
      shortDescription: error,
      stacktrace,
    },
  });
};

const updateAccount = (userRole: UserRole, data: UpdateAccountPasswordForm | UpdateAccountDataForm): Promise<{ data: { data: { token?: string }, message: string | null }}> => {
  return http.request({
    url: userRole === UserRole.ROLE_SUPER_USER ? '/users/super-users/profile' : userRole === UserRole.ROLE_ACCOUNT_MANAGER ? '/users/account-managers/profile' : '',
    method: ApiMethods.PUT,
    data,
  });
};

const UserService = {
  signIn,
  getAccountData,
  updateAccount,
  getAppData,
  signOut,
  logError,
  requestResetPassword,
  validateResetPasswordToken,
  resetPassword,
};

export default UserService;
